export default "__VITE_ASSET__3d917126__"